<div>
    <nz-modal [(nzVisible)]="isVisible" [nzMaskClosable]="false" nzTitle="Please verify recaptcha"
      (nzOnCancel)="handleCancel()">
      <ng-container *nzModalContent>
        <form [formGroup]="recaptchaForm">
          <div class="input-group mb-3">
            <input type="text" class="form-control" placeholder="" formControlName="captcha"  [(ngModel)]="userInput"
                   [ngClass]="{'is-invalid':recaptchaForm.get('captcha')?.touched && recaptchaForm.get('captcha')?.invalid}"
                   required />

            <div id="captcha" class="input-group-prepend rounded-end" style="background-color: rgb(220, 220, 220);">
            </div>
            &nbsp;
            <button type="button" class="btn btn-primary" style="width: 50px;" (click)="refreshCaptcha()">↻</button>
            <div class="invalid-feedback">
              <div>captcha is required!</div>
            </div>
            <div class="invalid-feedback" *ngIf="captchaError">
              <div>Invalid Captcha!</div>
            </div>

          </div>

        </form>

      </ng-container>
      <div *nzModalFooter ><button (click)="verify()" nz-button [nzType]="'primary'" style="margin-right: 7px">
        Verify
      </button></div>
    </nz-modal>
  </div>
